export default function SiteInstruction() {
    return (
        <div className=" p-5 bg-zinc-200 bg-opacity-70 shadow">
            {/* <h1 className='text-center text-4xl font-bold text-blue-500'>Study Schedule</h1> */}
            <h1 className="text-center font-sans font-semibold text-3xl lg:text-4xl text-sky-900 p-3">
                Oraysa Calendar
            </h1>
            <h2 className="text-center text-2xl lg:text-3xl font-bold text-sky-900 shadow-md p-3">
                Find out the Date when you will be learning each Amud
            </h2>
            {/* <p className="text-center text-xl font-bold text-sky-700 p-3">Enter an amud to find out witch day it will be studied on</p> */}
        </div>
    );
}
